<template>
  <main class="home-layout">
    <div>
      <HeroSection class="hero-section" />

      <FeaturedProjects class="container container--wide section" />

      <FeaturedDemos class="container section" />

      <RecentArticles class="container section" />
    </div>
  </main>
</template>

<script setup lang="ts">
import HeroSection from "../homepage/HeroSection.vue";
import FeaturedDemos from "./FeaturedDemos.vue";
import FeaturedProjects from "./FeaturedProjects.vue";
import RecentArticles from "./RecentArticles.vue";
</script>

<style scoped lang="scss">
.home-layout {
  min-height: 100vh;
  padding: var(--space-xl) var(--space-lg);
  max-width: 100%;
}

.hero-section {
  margin-bottom: var(--space-6xl);
}

.container {
  max-width: 100%;
  margin: 0 auto;
  width: var(--content-width-narrow);

  &--wide {
    width: var(--content-width-default);
  }
}

.section {
  margin-bottom: var(--space-6xl);
}
</style>
